/* Runtime-generated particle sprites — no asset download cost. Soft
   Gaussian "puff" PNGs are produced once on first request and cached as
   data URLs.

   Each puff uses a 5-stop radial gradient that approximates exp(-2t²) —
   soft Gaussian-ish falloff with a gentle bright core, going fully
   transparent at the edge so overlapping puffs alpha-stack cleanly.

   Why pre-tinted variants instead of @tsparticles/shape-image's
   `replaceColor: true`: the runtime tint flag silently does nothing in
   the current build, so coloured palettes (FIRE_COLORS) all render as
   the white base sprite. Baking one PNG per palette colour and handing
   tsparticles an `image: [...]` array sidesteps the issue — the particle
   randomly picks one tinted sprite at spawn time, and the gradient is
   in the correct colour from frame zero. */

const SIZE = 128;

let whitePuff: string | null = null;
const tintedPuffs = new Map<string, string>();

function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const h = hex.replace("#", "");
  const v = parseInt(h, 16);
  return { r: (v >> 16) & 0xff, g: (v >> 8) & 0xff, b: v & 0xff };
}

function makePuff(rgb: { r: number; g: number; b: number }): string {
  const c = document.createElement("canvas");
  c.width = SIZE;
  c.height = SIZE;
  const ctx = c.getContext("2d");
  if (!ctx) throw new Error("2d context unavailable");
  const r = SIZE / 2;
  const grad = ctx.createRadialGradient(r, r, 0, r, r, r);
  const { r: rr, g: gg, b: bb } = rgb;
  grad.addColorStop(0.0, `rgba(${rr},${gg},${bb},1.00)`);
  grad.addColorStop(0.25, `rgba(${rr},${gg},${bb},0.62)`);
  grad.addColorStop(0.5, `rgba(${rr},${gg},${bb},0.27)`);
  grad.addColorStop(0.75, `rgba(${rr},${gg},${bb},0.08)`);
  grad.addColorStop(1.0, `rgba(${rr},${gg},${bb},0.00)`);
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, SIZE, SIZE);
  return c.toDataURL("image/png");
}

export function getPuffSpriteUrl(): string {
  if (!whitePuff) whitePuff = makePuff({ r: 255, g: 255, b: 255 });
  return whitePuff;
}

export function getTintedPuffSpriteUrl(hex: string): string {
  const cached = tintedPuffs.get(hex);
  if (cached) return cached;
  const url = makePuff(hexToRgb(hex));
  tintedPuffs.set(hex, url);
  return url;
}

export const PUFF_SPRITE_SIZE = SIZE;
